import React, { Component } from 'react';
import store from '../store';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import DoneIcon from '@material-ui/icons/Done';

import createHistory from 'history/createBrowserHistory';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Chip from '@material-ui/core/Chip';
import { Link } from 'react-router-dom';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import BackIcon from '@material-ui/icons/ChevronLeft';
import { Redirect } from 'react-router-dom';
import Modal from 'react-responsive-modal';
import firebase from "firebase/app";
import "firebase/firestore";
import _ from 'lodash'
import LessonComp from "../components/LessonComp"
import ButtonBase from '@material-ui/core/ButtonBase';
import * as STATIC from '../config/static';
import CheckIcon from '@material-ui/icons/Check';
import moment from 'moment';
import { VictoryBar,VictoryLine,VictoryChart,VictoryTheme,VictoryLabel,VictoryAxis,VictoryScatter,VictoryLegend } from 'victory';
import Advance from './Advance';
import InnerPage from './InnerPage';
import CircularProgress from '@material-ui/core/CircularProgress';
import TopBar from '../components/TopBar';
const days = [0, 1, 2, 3, 4, 5];
const defaultSetting = {
  type: [],

  rows: 3,
  showTime: 6,
  answerTime: 10,
  qCount: 10,
  maxNumber: 10,
  digits: 1,
  digits1: 1,
  digits2: 1,
  displaySetting: 0,
  displayShow: 0,
  lessThan0: 0
}

function searchLabel(array, value) {
  let rel = '';
  let index = array.findIndex(a => a.value == value);
  if (index > -1) {
    rel = array[index].label;
  }
  return rel;
}
let _this;
const DWIDTH = 980;
const testData = [{name:'Week1',percent:40,total:2},{name:'Week2',percent:60,total:4}];
const testDataDay = [{name:'Day 1',percent:10},{name:'Day 2',percent:20},{name:'Day 3',percent:30},{name:'Day 4',percent:40},{name:'Day 5',percent:50},{name:'Day 6',percent:60}]
class Practice extends Component {
  constructor() {
    super();
    _this = this;
    this.state = { wWidth: 0, wHeight: 0, message: '',loading:true, showResult: false,showResultDetail:false, curWeek: -1, curDay: -1, course: null,result:{},showChart:false,isGuest:false,g_practice:false,curLegend:'All',saving:false,saving_error:false,isMore:0};
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  handleChange = name => event => {

    event.preventDefault();
    this.setState({
      [name]: event.target.value

    });


  }

  handleDelete = (name, value) => {
    let change = _this.state[name];
    //console.log(name,value,change);
    change = _.without(change, value);
    //  console.log(change);
    this.setState({
      [name]: change
    });
  }
  async loadPoint(){
    let ACCOUNT = store.getState().ACCOUNT;
    let doc =  await firebase.firestore().collection("data_students").doc("data_students"+'-'+ACCOUNT.id).get();
    if(doc.exists)
    {
      let newAcc = doc.data();
      ACCOUNT.point = newAcc.point?newAcc.point:0;
      if(newAcc.enable==0)
      {
        localStorage.removeItem('ACCOUNT');
        store.dispatch({ type: 'ACCOUNT', ACCOUNT: false });
        window.location = '/';
      }
      _this.setState({});
    }
  }
  async loadCourse() {
    let ACCOUNT = store.getState().ACCOUNT;
    //console.log(ACCOUNT.idkhoahoc)
    try {
      let sACC = false;
      if(ACCOUNT.type==0)
      {
        let aDoc =  await firebase.firestore().collection('data_students').doc('data_students-'+ACCOUNT.id).get();
        if(aDoc.exists){
          sACC = aDoc.data();
        }
      }
      else {
        _this.setState({loading:false})
        return;};
      let data = await firebase.firestore().collection('courses').where('course_id','==',ACCOUNT.idkhoahoc).get();
      if (data.size>0) {
        let item = {};
        data.forEach((doc)=>{
          item = doc.data();
          item.id = doc.id;
        })
        if (item.weeks)
        {
          let doc =  await firebase.firestore().collection("data_students").doc("data_students"+'-'+ACCOUNT.id).collection('lastdays').doc(item.id).get();

          let LASTDAY = {week:0,day:1}
          if(doc.exists)
          {
            LASTDAY = doc.data();
          }

          store.dispatch({ type: 'LASTDAY', LASTDAY });

          let fromdate = item.startDate;
          let todate = item.endDate;

          if(sACC)
          {
            lastday = STATIC.getBusinessDays(moment(),moment(sACC.fromdate));
            fromdate = sACC.fromdate;
            todate = sACC.todate;
          }

          fromdate = moment(fromdate);
          todate = fromdate.clone().add(item.week*7,"days");;

          //let todate = fromdate.add(item.week*7,"days");


        //  console.log(1,todate.format("L"),fromdate.format("L"));

          let hData =  await firebase.firestore().collection("data_holiday").where('idchinhanh','==',ACCOUNT.idchinhanh).orderBy("fromdate").get();
          let items = [];
          if(hData.size>0)
          {

            hData.forEach(hDoc=>{
              let hItem = hDoc.data();
              items.push(hItem);
            })

            let checkDate = STATIC.checkTodate(items,fromdate,todate,item.week);
            todate = checkDate.todate;
            fromdate = checkDate.fromdate;
          }
          if(moment().isSameOrBefore(todate))
          {
            todate = moment();
          }
          //console.log(2,todate.format("L"),fromdate.format("L"));
          let lastday = STATIC.getBusinessDays(todate,fromdate);
          //console.log(lastday);
          let holiday = 0;



          if(hData.size>0)
          {

            hData.forEach(hDoc=>{
              let hItem = hDoc.data();
              if(moment(hItem.fromdate).isBetween(fromdate,todate,'day','[]')||moment(hItem.todate).isBetween(fromdate,todate,'day','[]')||(fromdate.isBetween(moment(hItem.fromdate),moment(hItem.todate),'day','[]')&&todate.isBetween(moment(hItem.fromdate),moment(hItem.todate),'day','[]'))){

                let tHoliday = 0;
                if(moment(hItem.fromdate).isBetween(fromdate,todate,'day','[]')&&moment(hItem.todate).isBetween(fromdate,todate,'day','[]'))
                {
                  tHoliday = STATIC.getBusinessDays(moment(hItem.todate),moment(hItem.fromdate));

                }
                else if(moment(hItem.fromdate).isBetween(fromdate,todate,'day','[]'))
                {
                  tHoliday = STATIC.getBusinessDays(todate,moment(hItem.fromdate));

                }
                else if(moment(hItem.todate).isBetween(fromdate,todate,'day','[]')) {
                  tHoliday = STATIC.getBusinessDays(moment(hItem.todate),fromdate);
                }
                else {
                  tHoliday = lastday;
                }
                //console.log(tHoliday);
                holiday+=tHoliday;
              }
            })
          }
        //  console.log(lastday,holiday);
          //console.log(sACC.fromdate,lastday);
          lastday = lastday - holiday;
        //  console.log(lastday);
          if(lastday<0)
          lastday = 0;
        //  console.log(lastday,moment().format(),moment(sACC.fromdate,'MM/DD/YYYY hh:mm:ss A').format());
          let cWeek = Math.ceil((lastday+1)/6)-1;
          let cDay = lastday%6;
          //cWeek = 12;
          //console.log(cWeek,item.week-1);
          if(cWeek>item.week-1){
            cWeek = item.week-1;
            cDay = 5;
          }
          item.cWeek = cWeek;
          item.cDay = cDay;
          _this.setState({ course: item });
        }


      }
    }
    catch(e)
    {
      console.log(e);
    }

    _this.setState({loading:false});

  }
  async loadPracticeGuest() {
        let g_practice = false;
          try {
        let aDoc =  await firebase.firestore().collection('guest').doc('practice').get();
        if(aDoc.exists){
          g_practice = aDoc.data();
        }
      }
      catch(e)
      {
        console.log(e);
      }
        _this.setState({g_practice,isGuest:true,loading:false});

  }
  getStar(result) {

    let curStar = 0;
    let curMin = 100;
    for (let i = 0; i < 7; i++) {
      let newMin = Math.abs(i / 6 * 100 - result);
      console.log(newMin);
      if (newMin < curMin) {
        curStar = i / 2;
        curMin = newMin;
      }
    }
    if (curStar == 3 && result != 100)
      curStar = 2.5;
    return curStar;
  }
  async componentWillMount(){

  }

  async componentDidMount() {


    //console.log('Business',days);
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    let checked = await STATIC.checkVersion();
    if(checked!=true)
    {
      //console.log(checked);
      store.dispatch({ type: 'UP_VER', UP_VER: checked });
    }
    let ACCOUNT = store.getState().ACCOUNT;
    let isGuest = false;
    if(ACCOUNT.type==0)
    {
      if(!ACCOUNT.idlop)
      {
        this.loadPracticeGuest();
        isGuest = true;
      }
      else {
        let diff = moment(ACCOUNT.todate).diff(moment(), 'days');

        if(diff<=-10)
        {
          let data = await firebase.firestore().collection('courses').where('course_id','==',ACCOUNT.idkhoahoc).get();
          let week = 12;
          if (data.size>0) {
            let item = {};
            data.forEach((doc)=>{
              item = doc.data();
              week = item.week;
            })
          }
          let fromdate = moment(ACCOUNT.fromdate);
          let todate = moment(ACCOUNT.fromdate).add(week*7,"days");
          diff = todate.diff(moment(), 'days');
          //console.log(fromdate,week,todate.format("LLLL"));
          if(moment().isAfter(todate))
          {

            let hData =  await firebase.firestore().collection("data_holiday").where('idchinhanh','==',ACCOUNT.idchinhanh).orderBy("fromdate").get();
            if(hData.size>0)
            {
              let items = [];
              hData.forEach(hDoc=>{
                let hItem = hDoc.data();
                items.push(hItem);
              })
              let checkDate = STATIC.checkTodate(items,fromdate,todate,week)
              todate = checkDate.todate;
            }
            diff = todate.diff(moment(), 'days');
            //console.log(diff,todate.format());
            if(diff<=-10)
            {
              this.loadPracticeGuest();
              isGuest = true;
              STATIC.NotificationManager.error(this.props.t("practice.course_expired",{date:todate.format("DD/MM/YYYY")}));
            }

          }


          //console.log(diff,holiday,diff+holiday);


        }
      }
    }
    if(!isGuest)
    {
      this.loadCourse();
      this.loadPoint();
    }
    // let LASTDAY = localStorage.getItem('LASTDAY');
    // if (LASTDAY) {
    //   LASTDAY = JSON.parse(LASTDAY);
    //   store.dispatch({ type: 'LASTDAY', LASTDAY });
    // }
    // else {
    //   LASTDAY = { week: 0, day: 1 };
    //   store.dispatch({ type: 'LASTDAY', LASTDAY });
    //   localStorage.setItem('LASTDAY', JSON.stringify(LASTDAY));
    // }

  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ wWidth: window.innerWidth, wHeight: window.innerHeight });
  }


  getResultText(curStar) {
    let resultText = "Good";
    if (curStar == 3) {
      resultText = "Perfect";
    }
    else if (curStar == 2.5) {
      resultText = "Excellence";
    }
    else if (curStar > 1 && curStar <= 2) {
      resultText = "Very Good";
    }
    return resultText;
  }


  submitForm(e) {
    e.preventDefault();
    _this.setState({ submitted: true });
  }
  getFinishForWeek(t) {
    return 0;
    return 6 - t % 6 == 0 ? 1 : 6 - t % 6;
  }
  getStarForDay(t, size = 30) {
    let array = [];
    for (let i = 1; i <= 3; i++) {
      let item = (<StarIcon key={i} style={{ fontSize: size }} />);
      if (i > t) {
        item = (<StarBorderIcon key={i} style={{ fontSize: size }} />);
      }
      array.push(item);
    }
    return array;
  }
  async onLessonEnd(questions) {
    //console.log(questions);
    let count = 0;
    let countCorrect = 0;
    for (let q of questions) {
      if (q.status) {
        count++;
        if (q.status == 1) {
          countCorrect++;
        }
      }
    }

    // if(count==countCorrect&&count==questions.length)
    // {
    //   _this.setState({showSignUp:true});
    // }
    let {course,curWeek,curDay,isMore} = _this.state;
    let selectedDay = course.weeks["w" + curWeek] ? course.weeks["w" + curWeek]["d" + curDay] ? course.weeks["w" + curWeek]["d" + curDay] : false : false;
    let passPercent = selectedDay.percent?selectedDay.percent:80;

    let percent = Math.round(countCorrect / questions.length * 100);

    let ACCOUNT = store.getState().ACCOUNT;
    let nResult = {id_student:ACCOUNT.id,questions,percent,countCorrect,qlength: questions.length,id_course:_this.state.course.id,passPercent,week:_this.state.curWeek,day:_this.state.curDay,point:0}
    let point = 0;

    //if(selectedDay.point&&course.cWeek == curWeek&&course.cDay == curDay&&percent>=passPercent)
    if((selectedDay.point&&course.cWeek == curWeek&&percent>=passPercent||(course&&course.nodaycheck==1&&percent>=passPercent))&&isMore==0)
    {
      nResult.point = parseInt(selectedDay.point);
      point = parseInt(selectedDay.point);
      ACCOUNT.point = ACCOUNT.point+point;
    }
    let key = JSON.stringify({id:ACCOUNT.id,time:(new Date().getTime())});
    nResult.key = STATIC.encryptStringWithRsaPublicKey(key);
    _this.postResultToServer(nResult);

    _this.setState({ showResult: true,result:{percent,passPercent,countCorrect,qlength: questions.length,questions,point},nResult });
  }
  async postResultToServer(result){
  //  console.log("post result");
  if(!result)
  {
    _this.setState({saving:false,saving_error:false});
    return;
  }
 await  _this.setState({saving:true,saving_error:false});
    let LASTDAY = store.getState().LASTDAY;
    let day = result.day+1;
    let week = result.week;
    console.log(week,day);
    if(result.passPercent<=result.percent)
    {

      if(day>=6)
      {
        week+=1;
        day = 1;

      }
      else {
        day +=1;
      }

      console.log(week,day);
      LASTDAY = {week,day};
    }
    //console.log(JSON.stringify(result));
    //return;
    //let res = await STATIC.postFormData("http://localhost:5000/vnsuperbrain/us-central1/Student_PostResultAdvance2",{result:JSON.stringify(result)});
    let res = await STATIC.postFormData(STATIC.API_STUDENT_POSTRESULT,{result:JSON.stringify(result),lweek:week,lday:day});
    //console.log(res);
    if(res)
    {
      if(res.status==0)
      {
        if(res.message=='Key not correct')
        {
          await  _this.setState({saving:false});
          store.dispatch({ type: 'LASTDAY', LASTDAY });
        }
        else {
          await  _this.setState({saving_error:true});
          let docid = "L"+(new Date().getTime());
          firebase.firestore().collection("results_error").doc(docid).set({...result,type:'lesson',created:(new Date().getTime())});
        }
      }
      else {
        await  _this.setState({saving:false});
        store.dispatch({ type: 'LASTDAY', LASTDAY });
      }
    }
    else {
      await  _this.setState({saving_error:true});
      let docid = "L"+(new Date().getTime());
      firebase.firestore().collection("results_error").doc(docid).set({...result,type:'lesson',created:(new Date().getTime())});
    }

  }
  onAdvanceEnd(questions) {
    //console.log(questions);
    let count = 0;
    let countCorrect = 0;
    for (let q of questions) {
      if (q.status) {
        count++;
        if (q.status == 1) {
          countCorrect++;
        }
      }
    }

    // if(count==countCorrect&&count==questions.length)
    // {
    //   _this.setState({showSignUp:true});
    // }

    let percent = Math.round(countCorrect / questions.length * 100);
    _this.setState({ showResultDetail: true,result:{percent,countCorrect,qlength: questions.length,questions} });
  }

  backClick() {
    //console.log(_this.state.isGuest);
     if(_this.state.showAdvance)
    {
      _this.setState({ showAdvance:false });
    }
    else
    if (_this.state.curDay > -1) {
      _this.setState({ curDay: -1, curWeek: -1 });
    }

    else {
      this.props.history.push('/');
    }
  }
  onCloseModal(e) {
    _this.setState({ showResult: false, curDay: -1 })
  }
  checkInner(week){
    let INNERS = store.getState().INNERS;
    //if(INNERS && INNERS[_this.state.course.id+'-w'+week])
    if(INNERS&&!_.isEmpty(INNERS))
    {
      return true;
    }
  //  console.log(_this.state.course.id+'-w'+week);
    let innerTime = _this.state.course.weeks['w'+week].innerTime?_this.state.course.weeks['w'+week].innerTime:60;
    _this.setState({showInner:{id:_this.state.course.id+'-w'+week,innerTime}});
  //  console.log(innerTime);
    return false;
  }
  onInnerEnd(){
    let INNERS = store.getState().INNERS;
    INNERS[_this.state.showInner.id]=new Date().getTime();
    localStorage.setItem('INNERS', JSON.stringify(INNERS));
    _this.setState({showInner:false});
    _this.continueWeek(_this.state.cObject.LASTDAY,_this.state.cObject.week);
  }
  continueWeek(LASTDAY,week) {

    let course = _this.state.course;
    let {cDay,cWeek} = course;
    _this.setState({cObject:{LASTDAY,week},isMore:0});
    // if(_this.checkInner(LASTDAY.week))
    // {
    //   if(LASTDAY.week!=week)
    //   {
    //     _this.setState({ curWeek: week, curDay: 0 });
    //   }
    //   else {
    //     _this.setState({ curWeek: LASTDAY.week, curDay: LASTDAY.day - 1 })
    //   }
    // }
    // return;
    if(LASTDAY.week==week)
    {
      if(cWeek==week)
      {
        if(cDay>=LASTDAY.day - 1)
        {
          if(_this.checkInner(LASTDAY.week))
          _this.setState({ curWeek: LASTDAY.week, curDay: LASTDAY.day - 1 })
        }
        else {
          STATIC.NotificationManager.error(_this.props.t('practice.no_more'));
        }
      }
      else
      if(cWeek>week)
      {
        if(_this.checkInner(LASTDAY.week))
        _this.setState({ curWeek: LASTDAY.week, curDay: LASTDAY.day - 1 })
      }
      else {
        STATIC.NotificationManager.error(_this.props.t('practice.no_more'));

      }


    }
    else {
      // console.log(week,cWeek);
      // if(week==cWeek&&window.confirm(_this.props.t('practice.want_skip')+(cDay+1)+"/"+_this.props.t('common.week')+" "+(cWeek+1)))
      // {
      //   if(_this.checkInner(cWeek))
      //   _this.setState({ curWeek: cWeek, curDay: cDay })
      // }
    }
  }
getQuestionEQ(question,width)
{
  let rel = '';
  if(question.type!="image"&&question.type!="soroban")
  {

    for(let num of question.numbers)
    {
      if(question.type!='multiple'&&question.type!='divide')
      {
        if(rel=='')
        {
          rel=num;
          continue;
        }
        else {
          rel += (num>=0?' + ':' - ')+Math.abs(num);
        }
      }
      else {
        if(rel=='')
        {
          rel+=num;
        }
        else {
          rel+=""+num;
        }
      }

    }
  }
  else
  if(question.type=="soroban")
  {
    rel = "Soroban";
  }
  else {
    rel = (<div style={{display:'inline-block'}}>{question.images.map((i,index)=>{
      i = i.replace('_','-');
      i = i.replace('finger/f','finger/');
      return (<img key={"image"+index}
  src={i}
  style={{width: STATIC.calSize(30, STATIC.DWIDTH, width), height: 'auto'}} />)
    })}

    </div>)
  }
  return rel;
}
async showChartResult(){
  let {course} = _this.state;
  if(!course)
  course={id:"0",week:12};
  let ACCOUNT = store.getState().ACCOUNT;
  //await _this.setState({loading:true});
  let doc = await firebase.firestore().collection('data_students').doc("data_students"+'-'+ACCOUNT.id).collection("results").doc(course.id).get();
  let RESULTS = [];
  let chartData = [];
  let aData = await firebase.firestore().collection('data_students').doc("data_students"+'-'+ACCOUNT.id).collection(course.id).orderBy("created", "desc").get();
  if(aData.size>0)
  {
    aData.forEach(doc=>{
      let r = doc.data();
      RESULTS.push(r);
    })
  }
  if(doc.exists)
  {
    let rArr = doc.data().results;
    rArr.forEach(item=>{
      RESULTS.push(item);
    });
  }
  for(let i=0;i<course.week;i++)
  {
    let filtered = RESULTS.filter(t=>t.week==i);

    let percent = _.sumBy(filtered, 'percent');
    //console.log(filtered,percent);
    percent = percent?Math.round(percent/filtered.length):0;
    let item = {name:(i+1).toString(),percent,length:filtered.length};
    chartData.push(item);
  }
  //console.log(chartData);
  let doc2 = await firebase.firestore().collection('data_students').doc("data_students"+'-'+ACCOUNT.id).collection("results").doc('_ADVANCE_').get();
  let RESULTS2 = [];
  let chartData2 = [];
  let dateList = [];
  for(let i=9;i>=0;i--)
  {
    let item =  moment().subtract(i, "days").format("YYYY-MM-DD");
    dateList.push(item);
  }
  let startDate = moment().subtract(9, "days").format("YYYY-MM-DD")+" 00:00:00";


    let legends = [];
    let keyOptions = ['All'];
    let aData2 = await firebase.firestore().collection('data_students').doc("data_students"+'-'+ACCOUNT.id).collection("_ADVANCE_").where("created",">=",moment(startDate).valueOf()).orderBy("created", "desc").get();
    let rArr = [];
    if(aData2.size>0)
    {
      aData2.forEach(doc=>{
        let r = doc.data();
        rArr.push(r);
      })
    }
    console.log(rArr);
  if(doc2.exists)
  {
     rArr = rArr.concat(doc2.data().results);
   }
   if(rArr.length>0) {

    rArr.forEach(item=>{
      item.date=moment(item.created).format('YYYY-MM-DD');
      if(item.date>=dateList[0]&&item.group!=undefined)
      {
        if(item.group&&item.group!="")
        {
          RESULTS2.push(item);
        }



      }
    });
    RESULTS2 = _.sortBy(RESULTS2,['date'],['desc']);
    RESULTS2 = _.groupBy(RESULTS2,'group');


    for (let key of Object.keys(RESULTS2))
    {
      let agroup = STATIC.AGROUP[key];
      //console.log("key1",key);
      if(!agroup)
      {
        console.log("key2",key);
        return;
      }
      legends.push({name:key,symbol:{fill:agroup.color,type:agroup.symbol}});
        keyOptions.push(key);
      let tArr= [];
      for(let rel of dateList)
      {
        //console.log(rel);
        let arr = RESULTS2[key].filter(i=>i.date==rel);
        let percent = 0;
        if(arr.length>0)
        {
           percent = _.sumBy(arr, 'percent');
          percent = percent?Math.round(percent/arr.length):0;
        }

      //  console.log(arr);

        let item = {name:moment(rel,'YYYY-MM-DD').format('DD-MM').toString(),y:percent,...STATIC.AGROUP[key],key,date:rel};
        tArr.push(item);
      }

      chartData2.push(tArr);
    }

  }
  _this.setState({showChart:true,chartData,RESULTS,RESULTS2,legends,keyOptions,curLegend:'All',chartData2,showAdvanceResult:false});
}
async showChartDetailResult(index){
  let {chartData,RESULTS} = _this.state;
  let chartDetailData = [];
  for(let i=0;i<6;i++)
  {
    let filtered = RESULTS.filter(t=>t.week==index&&t.day==i);
    let percent = _.sumBy(filtered, 'percent');
//console.log(filtered,percent);
    percent = percent?Math.round(percent/filtered.length):0;
    let item = {name:(i+1).toString(),percent,length:filtered.length};
    chartDetailData.push(item);
  }
  _this.setState({showChartDetail:true,chartDetailData,chartWeekIndex:index});
}
clickChart(index)
{
  if(_this.state.showChartDetail)
  {
    let {chartWeekIndex,RESULTS} = _this.state;
    let filtered = RESULTS.filter(t=>t.week==chartWeekIndex&&t.day==index);
    if(filtered&&filtered.length>0)
    _this.setState({showResultDetail:true,fResults:filtered,result:filtered[0],rIndex:0});
    return;
  }
  _this.showChartDetailResult(index);
}
clickChart2(key,date)
{

    let {RESULTS2} = _this.state;
    let filtered = RESULTS2[key].filter(i=>i.date==date);
    if(filtered&&filtered.length>0)
    _this.setState({showResultDetail:true,fResults:filtered,result:filtered[0],rIndex:0});


}
changeResult(index)
{
  let {fResults} = _this.state;
  if(index<=fResults.length-1&&index>=0)
  {
    _this.setState({result:fResults[index],rIndex:index});
  }
}
  render() {
    const { classes,t } = this.props;
    const { wWidth, wHeight,loading, curWeek, curDay, showResult, course,result,showAdvance,showResultDetail,title,showChart,showInner,isGuest,legends,saving,saving_error } = this.state;
    let width = DWIDTH;
    if (wWidth < DWIDTH) {
      width = wWidth;
    }
    let sRate = 640 / 1010;
    if ((curWeek > -1 && curDay > -1)||showAdvance) {
      sRate = 980 / 640;
    }
    if (width / wHeight > sRate) {
      width = wHeight * sRate;
    }
    if(showResult)
    {
      let rRate = 800/722;
      if (width / wHeight > rRate) {
        width = wHeight * rRate;
      }
      //console.log(wHeight * rRate);
    }
    let fLarge = width * 0.06;
    let fTitle = width * 0.04;
    let fNormal = width * 0.03;
    let fSmall = width * 0.02;
    let bRate = 391 / 271;

    let bWidth = width / 3;
    let bHeight = bWidth / bRate;
    let bConWidth = bWidth * 0.25 * 10;
    let weeks = [];
    if (course) {

      for (let i = 0; i < course.week; i++) {
        weeks.push(i);
      }

    }
    let selectedDay = false;
    if (curWeek > -1 && curDay > -1) {

      selectedDay = course.weeks["w" + curWeek] ? course.weeks["w" + curWeek]["d" + curDay] ? course.weeks["w" + curWeek]["d" + curDay] : false : false;
      if (!selectedDay) {
        alert("Not available!");
        this.setState({ curDay: -1, curWeek: -1 })
      }
      //console.log(selectedDay);
    }
    let chartData2 = this.state.chartData2;
    if(this.state.curLegend!=''&&this.state.curLegend!='All')
    {
      let index = this.state.keyOptions.indexOf(this.state.curLegend);
      console.log(index);
      if(index>-1 && chartData2.length>index-1)
      {
        chartData2 = [chartData2[index-1]];
      }
    }

    let LASTDAY = store.getState().LASTDAY;
    let ACCOUNT = store.getState().ACCOUNT;
    if (!ACCOUNT) {

      return (<Redirect to='/login' />);
    }
    let LANG = store.getState().LANG;
    if (loading) {

      return (<div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
        <div className={classes.middle}>
<TopBar width={width} />
          <div className={classes.square} style={{ maxWidth: width }} elevation={4}>
            <div style={{ padding: (STATIC.calSize(40, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(20, STATIC.DWIDTH, width) + 'px 0'), flexGrow: 1, position: 'relative' }}>
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), zIndex: -1 }} />
              <div style={{ marginBottom: STATIC.calSize(curWeek > -1 && curDay > -1 ? 10 : 30, STATIC.DWIDTH, width) }}>
                <div style={{ display: 'flex' }}>
                  <ButtonBase
                    focusRipple
                    onClick={() => this.backClick()}
                    style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                    <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                  </ButtonBase>
                  {showAdvance?<div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fTitle }}>{title}</div>: <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fTitle }}>{curWeek > -1 && curDay > -1 ? (<div>{t('common.day')} {curDay + 1} /<span style={{ fontSize: fSmall }}>{t('common.week')} {curWeek + 1}</span></div>) : t('practice.practice')}</div>}
                </div>

                <Divider style={{ marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), backgroundColor: "#053f22", height: STATIC.calSize(2, STATIC.DWIDTH, width) }} variant="middle" />

              </div>
              <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>

                  <div>
                  <CircularProgress style={{color:'rgb(5, 63, 34)'}}/>
                  </div>

              </div>
              <Link to="/" style={{ width: '100%' }}>
                <img
                  src="assets/web/logo_green.png"
                  style={{ maxWidth: 296, height: 'auto', marginTop: STATIC.calSize(20, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(20, STATIC.DWIDTH, width), width: STATIC.calSize(189, STATIC.DWIDTH, width) }} />
              </Link>
            </div></div>
          </div>
        </div>);
    }
    if(showAdvance||ACCOUNT.type==1||isGuest){
      return (<Advance g_practice={isGuest?this.state.g_practice:false} onClose={ACCOUNT.type==1||isGuest?null:()=>this.setState({showAdvance:false})} history={this.props.history} parentPath="/practice" />);
    }
    if(showInner){
      return (<InnerPage onEnd={()=>this.onInnerEnd()} timer={showInner.innerTime}  />);
    }

    return (
      <div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
        <div className={classes.middle}>
<TopBar width={width} screen={"practice"} />
          <div className={classes.square} style={{ maxWidth: width }} elevation={4}>
            <div style={{ padding: (STATIC.calSize(40, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(20, STATIC.DWIDTH, width) + 'px 0'), flexGrow: 1, position: 'relative' }}>
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), zIndex: -1 }} />
              <div style={{ marginBottom: STATIC.calSize(curWeek > -1 && curDay > -1 ? 10 : 30, STATIC.DWIDTH, width) }}>
                <div style={{ display: 'flex' }}>
                  <ButtonBase
                    focusRipple
                    onClick={() => this.backClick()}
                    style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                    <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                  </ButtonBase>
                  {showAdvance?<div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fTitle }}>{title}</div>: <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fTitle }}>{curWeek > -1 && curDay > -1 ? (<div>{t('common.day')} {curDay + 1} /<span style={{ fontSize: fSmall }}>{t('common.week')} {curWeek + 1}</span></div>) : t('practice.practice')+(course&&course.cWeek!=undefined?'(W'+(course.cWeek+1)+'/D'+(course.cDay+1)+')':'')}</div>}
                </div>

                <Divider style={{ marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), backgroundColor: "#053f22", height: STATIC.calSize(2, STATIC.DWIDTH, width) }} variant="middle" />

              </div>
              {(curWeek == -1 || curDay == -1)&&!showAdvance ? (<div style={{position:'relative'}}>
                <Grid container direction="column" alignItems="center" justify="center" >
                  <Grid item>
                    <div style={{ position: 'relative', width: bConWidth,minHeight:100, height: (bHeight * Math.ceil((weeks.length) / 3) + bHeight * ((weeks.length - 1) % 3 / 2)) }}>
                      {curWeek == -1 ? weeks.map((t, index) => {
                        let row = Math.floor(index / 3);
                        let src = "assets/web/w0.png";
                        //console.log(LASTDAY);
                        // LASTDAY.week = 1;
                        // LASTDAY.day=1;
                        // course.cWeek = 1;
                        if (LASTDAY && LASTDAY.week == index&&LASTDAY.day!=1)
                          src = "assets/web/w" + (LASTDAY.day-1) + ".png";
                          else if(LASTDAY && LASTDAY.week > index)
                          src = "assets/web/w6.png";
                          else if(course.cWeek>=t)
                          {
                            src = "assets/web/w0-1.png";
                          }

                        return (<Button
                          onClick={() => this.continueWeek(LASTDAY,t)}
                          disabled={false&&course.cWeek<t}
                          key={"week" + index}
                          variant="contained"
                          style={{ position: 'absolute', zIndex: 1, top: bHeight * row + bHeight / 2 * (index % 3), left: bWidth * 0.25 * (3 * (index % 3)), width: bWidth, height: bHeight, padding: 0, cursor: 'pointer', clipPath: 'polygon(0% 50%, 25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%)' }}>
                          <img
                            src={src}
                            style={{ width: '100%', height: 'auto', display: 'block' }} />
                          <p style={{ position: 'absolute', top: 0, textAlign: 'center', color: 'white', fontSize: fNormal, margin: 0 }}>
                            {LANG=="en"?STATIC.addSuff(t+1):false} {this.props.t('common.week')} {LANG=="en"?true:t + 1}
                          </p>

                        </Button>)
                      }) : false}
                      {weeks.length==0?(<div style={{fontSize:fLarge}}>{t('practice.no_course')}</div>):false}


                    </div>
                  </Grid>
                </Grid>
                <Grid container direction="row">
                  <Button style={{marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fNormal, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained" onClick={()=>this.showChartResult()} >
                    {t('common.results')}
                  </Button><Button style={{marginTop: STATIC.calSize(5, STATIC.DWIDTH, width),marginLeft:'auto', color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fNormal, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained" onClick={()=>this.setState({showAdvance:true})} >
                  {t('common.advance')}
                                                  </Button>
                                                  </Grid>

                                                  <div style={{position: 'absolute', top: 0,right:0}}>
                                                    <Button style={{marginTop: STATIC.calSize(5, STATIC.DWIDTH, width),marginLeft:'auto', color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#053f2200', fontWeight: 'bold', fontSize: fNormal, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                                                      {ACCOUNT.point?ACCOUNT.point:0} {t('common.power')}
                                                                                      </Button>
                                                </div>
                <Link to="/" style={{ width: '100%' }}>
                  <img
                    src="assets/web/logo_green.png"
                    style={{ maxWidth: 296, height: 'auto', marginTop: STATIC.calSize(20, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(20, STATIC.DWIDTH, width), width: STATIC.calSize(189, STATIC.DWIDTH, width) }} />
                </Link>
              </div>) : false}



              {curWeek > -1 && curDay > -1 && selectedDay ? <LessonComp
                {...selectedDay}
                onLessonEnd={this.onLessonEnd}
              /> : false}

              {showAdvance ? <LessonComp
                showAdvance={true}
                updateTitle={(title)=>this.setState({title})}
                onLessonEnd={this.onAdvanceEnd}
              /> : false}


            </div>

            <Modal styles={{overlay:{padding:0}, modal: { minWidth: width * 0.8, background: 'none', boxShadow: 'none', color: "white" } }} showCloseIcon={false} focusTrapped={false} open={showResult&&!saving&&!saving_error} onClose={() => this.setState({ showResult: false })} center>
              <div style={{ width: width * 0.8, backgroundColor: 'rgba(101, 163, 67, 1)', position: 'relative', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), padding: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                <div style={{ width: width * 0.8 - STATIC.calSize(10, STATIC.DWIDTH, width) * 2, minHeight: 50, borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), border: '1px solid white', textAlign: 'center' }}>
                  <img
                    src={result.percent>=result.passPercent?"assets/web/icon_soroban_good.png":"assets/web/icon_soroban_bad.png"}
                    style={{ width: width * 0.3, height: 'auto', marginTop: STATIC.calSize(-63, STATIC.DWIDTH, width) }} />
                  <div style={{ color: 'white', fontSize: fLarge, fontWeight: 'bold' }}>
                    {result.percent>=result.passPercent?t('common.congratulation')+"!":t('common.tryagain')}
                                  </div>
                                  {result.percent>=result.passPercent?<div style={{color: 'rgb(5, 63, 34)', fontWeight: 'bold', fontSize: fLarge}}>
+{result.point?result.point:0} {t('common.power')}
</div>:false}

                  {result.percent>=result.passPercent?(<div style={{ display: 'flex', padding: STATIC.calSize(20, STATIC.DWIDTH, width), width: '100%' }}>
                  <Button style={{ color: "#053f22", borderRadius: STATIC.calSize(25, STATIC.DWIDTH, width), padding: (STATIC.calSize(8, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(24, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontSize: fNormal }}
                     color="primary" size="medium" variant="contained" onClick={() => this.setState({ showResult: false,isMore:1 })}>
                    {t('common.more')}
                        </Button>
                        <Button style={{ color: "#053f22", borderRadius: STATIC.calSize(25, STATIC.DWIDTH, width), padding: (STATIC.calSize(8, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(24, STATIC.DWIDTH, width) + 'px'),marginLeft:'auto', minWidth: 0, backgroundColor: '#fdce07', fontSize: fNormal }} color="primary" size="medium" variant="contained" onClick={() => this.setState({ showResult: false,showAdvance:true,curWeek:-1,curDay:-1 })}>
                          {t('common.advance')}
                              </Button>
                </div>):(<div style={{ display: 'flex', justifyContent: 'center', padding: STATIC.calSize(20, STATIC.DWIDTH, width), width: '100%' }}>
                    <Button style={{ color: "#053f22", borderRadius: STATIC.calSize(25, STATIC.DWIDTH, width), padding: (STATIC.calSize(8, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(24, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontSize: fNormal }} color="primary" size="medium" variant="contained" onClick={() => this.setState({showResult: false })}>
                      {t('common.resume')}
                          </Button>
                  </div>)}
                </div>
              </div>
              <div style={{ display: 'flex', padding: STATIC.calSize(18, STATIC.DWIDTH, width), width: '100%' }}>
                <div style={{ flexGrow: 1, padding: '0px '+STATIC.calSize(10, STATIC.DWIDTH, width)+'px' }}>
                  <div style={{ backgroundColor: 'rgb(253, 206, 7)', border: '2px solid white', height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), width: '100%', position: 'relative', overflow: 'hidden' }}>
                    <div style={{ position: 'relative', backgroundColor: 'rgb(101, 163, 67)', height: STATIC.calSize(40, STATIC.DWIDTH, width), width: result.percent+'%' }} />
                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, height: STATIC.calSize(40, STATIC.DWIDTH, width), textAlign: 'center', fontSize: fTitle, color: 'rgb(5, 63, 34)' }}>{result.percent}%</div>
                  </div>
                </div>
                <div onClick={()=>this.setState({showResultDetail:true})}>
                  <img
                    src="assets/web/icon_result.png"
                    style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width)}} />
                </div>
              </div>
              <div style={{ position: 'fixed', bottom: STATIC.calSize(50, STATIC.DWIDTH, width), left: 0, right: 0, textAlign: 'center' }}>
                <img
                  src="assets/web/logo_green.png"
                  style={{ width: width * 0.2, maxWidth: 296, height: 'auto', marginBottom: STATIC.calSize(-50, STATIC.DWIDTH, width), marginTop: STATIC.calSize(20, STATIC.DWIDTH, width) }} />
              </div>

            </Modal>


            <Modal styles={{overlay:{padding:0}, modal: { minWidth: width * 0.8, background: 'white',textAlign:'center' } }} open={showResultDetail} onClose={() => this.setState({ showResultDetail: false })} center>
              <div>
                  {result.created?<div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}>
                  {_this.state.rIndex>0?<Button style={{ color: "#053f22", borderRadius: STATIC.calSize(5, STATIC.DWIDTH, width), padding: (STATIC.calSize(1, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(5, STATIC.DWIDTH, width) + 'px'),marginRight:STATIC.calSize(10, STATIC.DWIDTH, width),backgroundColor:'white', minWidth: 0, fontSize: fSmall }} color="primary" size="medium" variant="contained" onClick={() => this.changeResult(this.state.rIndex-1)}>
                      {"<"}
                    </Button>:false}
                  <div style={{fontSize: fSmall}}>{moment(result.created).format("DD/MM/YYYY HH:mm")}</div>
                {_this.state.rIndex<_this.state.fResults.length-1?<Button style={{ color: "#053f22", borderRadius: STATIC.calSize(5, STATIC.DWIDTH, width), padding: (STATIC.calSize(1, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(5, STATIC.DWIDTH, width) + 'px'),marginLeft:STATIC.calSize(10, STATIC.DWIDTH, width),backgroundColor:'white', minWidth: 0, fontSize: fSmall }} color="primary" size="medium" variant="contained" onClick={() => this.changeResult(this.state.rIndex+1)}>
                    {">"}
                  </Button>:false}</div>:false}
                    <Grid container direction="row" style={{marginTop:STATIC.calSize(40, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(20, STATIC.DWIDTH, width)}} >
                        <Grid item xs={1} >
                          <div style={{fontSize: fSmall}}>{t('common.id')}</div>
                        </Grid>
                        <Grid item xs={5} >
                          <div style={{fontSize: fSmall,textAlign:'left'}}>{t('common.question')}</div>

                        </Grid>
                        <Grid item xs={2} >
                          <div style={{fontSize: fSmall}}>{t('common.input')}</div>

                        </Grid>
                        <Grid item xs={2} >
                          <div style={{fontSize: fSmall}}>{t('common.correct')}</div>

                        </Grid>
                        <Grid item xs={2} >
                          <div style={{fontSize: fSmall}}>{t('common.result')}</div>
                        </Grid>
                    </Grid>
                    <Divider />
                    {result&&result.questions?result.questions.map((q,index)=>{
                      return (<Grid key={index} container direction="row" style={{marginTop:STATIC.calSize(10, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(10, STATIC.DWIDTH, width)}} >
                          <Grid item xs={1} >
                            <div style={{fontSize: fSmall}}>{index+1}</div>
                          </Grid>
                          <Grid item xs={5} >
                            <div style={{fontSize: fSmall,textAlign:'left'}}>{this.getQuestionEQ(q,width)} =</div>

                          </Grid>
                          <Grid item xs={2} >
                            <div style={{fontSize: fSmall}}>{q.answer}</div>

                          </Grid>
                          <Grid item xs={2} >
                            <div style={{fontSize: fSmall}}>{q.result}</div>

                          </Grid>
                          <Grid item xs={2} >
                            <div style={{fontSize: fNormal,color:q.status==1?'green':"red"}}>{q.status==1?<CheckIcon style={{fontSize:fNormal}}/>:"X"}</div>
                          </Grid>
                      </Grid>)
                    }):false}
                    <Divider />
                    <div style={{textAlign: 'right', fontSize: fSmall, marginTop: STATIC.calSize(10, STATIC.DWIDTH, width)}}>{t('common.total')}: {result.countCorrect}/{result.qlength}<br />({result.percent}%)</div>
                  <div style={{textAlign: 'left', marginTop: STATIC.calSize(40, STATIC.DWIDTH, width)}}>
                    <img
                    src="assets/web/logo_green.png"
                    style={{width: width*0.2, maxWidth: 296, height: 'auto'}} />
                    </div>

              </div>
            </Modal>
            <Modal styles={{overlay:{padding:0}, modal: { minWidth: wWidth , background: 'white',textAlign:'center' } }} open={showChart} onClose={() => this.setState({ showChart: false,showChartDetail:false })} center>
              <div>
                <div style={{ display: 'flex' }}>
                  {this.state.showChartDetail&&!this.state.showAdvanceResult?<ButtonBase
                    focusRipple
                    onClick={() => this.setState({showChartDetail:false})}
                    style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                    <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                  </ButtonBase>:false}
                    <div style={{textAlign: 'center', flexGrow: 1, fontSize: fTitle, marginTop: STATIC.calSize(10, STATIC.DWIDTH, width)}}>{this.state.showChartDetail&&!this.state.showAdvanceResult?t('common.results_for_week')+(this.state.chartWeekIndex+1):t('common.results')}</div>
                    </div>
                    <div style={{textAlign: 'center', fontSize: fTitle, marginTop: STATIC.calSize(10, STATIC.DWIDTH, width)}}>{this.state.showAdvanceResult?t('common.aresults_for',{name:ACCOUNT.ten}):t('common.tresults_for',{name:ACCOUNT.ten})}</div>
                    {this.state.showAdvanceResult?<div>
                      <Grid container direction="row" style={{marginTop:STATIC.calSize(10, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(10, STATIC.DWIDTH, width)}}>
                        <Grid item>
                          <FormControl style={{ width: width * 0.2 }}>
                            <Select
                              value={this.state.curLegend}
                              onChange={e=>this.setState({curLegend:e.target.value})}

                              style={{ backgroundColor: '#fdce07', border: 'none', color: "#053f22", padding: 5, textAlign: 'left', fontSize: fNormal }}

                            >
                              {this.state.keyOptions.map((t, index) => {
                                return (<MenuItem style={{ fontSize: fNormal }} key={"province" + index} value={t}>
                                  {t}
                                </MenuItem>)
                              })}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                      <div style={{height:"500px",width:wWidth,marginBottom:STATIC.calSize(20, STATIC.DWIDTH, width)}}><VictoryChart
height={500} width={wWidth}
  domainPadding={22}
>

{chartData2.map((cData,index)=>{
  return [<VictoryScatter
    key={'sc'+index}
    style={{ data: { fill: ({ datum }) => datum.color } }}
    size={8}
    x="name"
    data={chartData2[index]}
    events={[{
        target: "data",
        eventHandlers: {
            onClick: () => {

                return [
                    {
                        target: "data",
                        mutation: (props) => {
                          let data = props.data[props.index];
                          _this.clickChart2(data.key,data.date);
                        }
                    },
                ];
            }
        }
    }]}
  />,<VictoryLine
    key={'VL'+index}
    interpolation="cardinal"
          data={chartData2[index]}
          x="name"

          labels={({ datum }) => datum.y+'%'}
          domain={ { y: [0, 100] } }
          style={{ labels: { fill: ({ datum }) => datum.color },data: { stroke: cData[0].color, strokeWidth: STATIC.calSize(1, STATIC.DWIDTH, width) },
       }}
          labelComponent={<VictoryLabel  dy={STATIC.calSize(10, STATIC.DWIDTH, width)*-1}/>}
          events={[
        {
          target: "data",
          eventHandlers: {
            onPress: () => {
              return [{
                target: "labels",
                mutation: (props) => {
                  console.log(props);
                  _this.clickChart2(props.index);
                  return null;
                }
              }];
            }
          }
        }
      ]}
           />]
})}
<VictoryLegend
    title=""
    centerTitle
    orientation="horizontal"
    itemsPerRow={6}
    gutter={STATIC.calSize(10, STATIC.DWIDTH, width)}
    style={{ border: { stroke: "black" }, title: {fontSize: 1 },labels: { fontSize:fSmall  } }}
    data={legends.filter(l=>this.state.curLegend==''||this.state.curLegend=='All'||this.state.curLegend==l.name)}
  />
         <VictoryAxis
         label={this.state.showAdvanceResult?'Date':!this.state.showChartDetail?t('common.week'):t('common.day')}

                   style={{
             axis: {stroke: "#756f6a"},
             axisLabel: {fontSize: 20, padding: STATIC.calSize(20, STATIC.DWIDTH, width)},

             ticks: {stroke: "grey", size: 5},
             tickLabels: {fontSize: fSmall, padding: STATIC.calSize(5, STATIC.DWIDTH, width)}
           }}

                 />
         <VictoryAxis
         dependentAxis
                   tickValues={[0,20,40,60,80,100]}


                 /></VictoryChart></div>
             </div>
                      :<div style={{height:"500px",width:wWidth,marginBottom:STATIC.calSize(20, STATIC.DWIDTH, width)}}><VictoryChart
height={500} width={wWidth}
  domainPadding={22}
>

<VictoryBar
        data={this.state.showAdvanceResult?this.state.chartData2:!this.state.showChartDetail?this.state.chartData:this.state.chartDetailData}
        x="name"
        y="percent"
        labels={({ datum }) => datum.percent!=0?datum.percent+'%':""}
        domain={ { y: [0, 100] } }
        style={{ labels: { fill: !this.state.showChartDetail?"white":"#053f22" },
      data: { fill: !this.state.showChartDetail?"#053f22":'#fdce07',width:STATIC.calSize(40, STATIC.DWIDTH, width) }
     }}
        labelComponent={<VictoryLabel dy={STATIC.calSize(20, STATIC.DWIDTH, width)}/>}
        events={[
      {
        target: "data",
        eventHandlers: {
          onClick: () => {
            return [{
              target: "labels",
              mutation: (props) => {
                _this.clickChart(props.index);
                return null;
              }
            }];
          }
        }
      }
    ]}
         />
         <VictoryAxis
         label={this.state.showAdvanceResult?'Date':!this.state.showChartDetail?t('common.week'):t('common.day')}

                   style={{
             axis: {stroke: "#756f6a"},
             axisLabel: {fontSize: 20, padding: STATIC.calSize(20, STATIC.DWIDTH, width)},

             ticks: {stroke: "grey", size: 5},
             tickLabels: {fontSize: fSmall, padding: STATIC.calSize(5, STATIC.DWIDTH, width)}
           }}

                 />
         <VictoryAxis
         dependentAxis
                   tickValues={[0,20,40,60,80,100]}


                 /></VictoryChart></div>}
                  <div style={{textAlign: 'left', marginTop: STATIC.calSize(40, STATIC.DWIDTH, width)}}>
                    <img
                    src="assets/web/logo_green.png"
                    style={{width: width*0.2, maxWidth: 296, height: 'auto'}} />
                    </div>
                    <Button style={{ color: "#053f22", borderRadius: STATIC.calSize(25, STATIC.DWIDTH, width), padding: (STATIC.calSize(8, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(24, STATIC.DWIDTH, width) + 'px'),marginLeft:'auto', minWidth: 0, backgroundColor: '#fdce07', fontSize: fNormal }} color="primary" size="medium" variant="contained" onClick={() => this.setState({ showAdvanceResult: !this.state.showAdvanceResult})}>
                      {this.state.showAdvanceResult?t('practice.practice'):t('common.advance')}
                          </Button>

              </div>
            </Modal>
            <Modal styles={{overlay:{padding:0}, modal: { minWidth: width * 0.8, background: 'none', boxShadow: 'none', color: "white" } }} showCloseIcon={false} focusTrapped={false} open={saving&&!saving_error} onClose={() => this.setState({ })} center>
              <div style={{ width: width * 0.8, position: 'relative', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), padding: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                <div style={{textAlign:'center'}}>
                <CircularProgress style={{color:'white'}}/>
                <div style={{fontSize:fNormal}}>{t('common.save_result')}</div>
                </div>
              </div>
            </Modal>
            <Modal styles={{overlay:{padding:0}, modal: { background: 'none',textAlign:'center' } }} onClose={()=>{}} showCloseIcon={false} focusTrapped={false} open={saving_error} center>
              <div style={{ width: "100%", backgroundColor: 'rgba(101, 163, 67, 1)', position: 'relative', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH), padding: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH) }}>
                <div style={{ display: 'flex',flexDirection:'column' }}>

                    <div style={{textAlign: 'center', fontSize: fNormal, marginTop: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH)}}>{t('common.saving_error')}</div>
                    <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center', marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                      <Button onClick={()=>this.setState({saving:false,saving_error:false})} style={{marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                        {t('common.close')}
                      </Button>
                      <div style={{flexGrow:1}}></div>
                      <Button onClick={()=>this.postResultToServer(this.state.nResult)} style={{marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                        {t('common.saving_retry')}
                      </Button>

                    </div>
                    </div>
                  </div>
                </Modal>
          </div>


        </div>

      </div>
    );
  }
}


Practice.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(STATIC.styles)(STATIC.translate('common')(Practice));
